import React from 'react';

const MEASUREMENT_COLUMNS = ['Objeto / lugar', 'Medida', 'Unidad'] as const;
const EQUIVALENCE_COLUMNS = ['Medida original', 'Unidad original', 'Equivalente', 'Unidad nueva'] as const;

export function PrintMeasurementTable({
  purpose = 'measurement_table',
  instruction,
  rowCount = 4,
}: {
  purpose?: string;
  instruction?: string;
  rowCount?: number;
}) {
  const columns =
    purpose === 'equivalence_table' ? [...EQUIVALENCE_COLUMNS] : [...MEASUREMENT_COLUMNS];

  return (
    <div className="print-measurement-table print:break-inside-avoid">
      {instruction ? <p className="print-instruction">{instruction}</p> : null}
      <table className="print-measurement-table__grid">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column} className="print-measurement-table__th">
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column) => (
                <td key={`${rowIndex}-${column}`} className="print-measurement-table__td" aria-hidden>
                  &nbsp;
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
